import { useField } from 'formik';

import { FormSection } from '@@/form-components/FormSection/FormSection';
import { SwitchField } from '@@/form-components/SwitchField';
import { Alert } from '@@/Alert';

const fieldKey = 'Policies';

export function EnablePoliciesSection() {
  const [{ value }, , { setValue }] = useField<boolean>(fieldKey);

  return (
    <FormSection
      title="Policy Based Management"
      id="additional-functionality-policies"
    >
      <div className="form-group col-sm-12">
        <Alert
          color="info"
          title="Policy Based Management is in active development and some functionality is limited:"
        >
          <ul>
            <li>
              Policies may fail to apply if there are existing settings at an
              environment level.
            </li>
            <li>
              Existing environment level settings will not restore when a policy
              is removed from an environment.
            </li>
            <li>
              At this time we recommend using Policy Based Management only for
              fresh new environments.
            </li>
          </ul>
        </Alert>
      </div>

      <div className="form-group col-sm-12">
        <Alert
          color="warn"
          title="Policy Based Management is for Edge (Standard) Agent environments. It requires Edge Agent >=2.37.0"
        />
      </div>

      <div className="form-group">
        <div className="col-sm-12">
          <SwitchField
            label="Policy Based Management"
            data-cy="enable-policies-switch"
            name={fieldKey}
            labelClass="col-sm-3 col-lg-2"
            checked={value}
            onChange={(checked) => setValue(checked)}
          />
        </div>
      </div>
    </FormSection>
  );
}
